<div class="navigation-page">
    <div class="ariane">
      <span><a class="link-ariane" routerLink="/">Musée de Carnac </a>
        <span *ngIf="collection !== undefined"><a [routerLink]="['/collection', slugify(collection)]" class="link-ariane">| {{rename(collection) | uppercase }} </a></span>
        <span class="pages">| {{ page | uppercase }}</span>
      </span>
    </div>
</div>
